<template>
    <p class="cart-not-compatible-info">
        W koszyku znajdują się niekompatybilne opcje dostaw produktów uniemożliwiające złożenie zamówienia.
    </p>
</template>

<script>
export default {
    name: 'CartNotCompatibleInfo',
};
</script>

<style lang="scss">
.cart-not-compatible-info {
    color: $color-deepCanynon;
    font: $font-weight-light 14px/20px $goodHomeFontFamily;
    @include colored-icon('i-warning', $color-deepCanynon);
    background-repeat: no-repeat;
    background-position-x: left;
    background-position-y: 3px;
    background-size: 30px;
    padding-left: 38px;
}
</style>
